import { matchPath } from 'react-router-dom';

export const LEGACY_LESSON_PATHS = [
  'activities/homework',
  'activities/:activityId/view',
  'help',
  'book/chapter/:chapterOrder',
  'book/chapter/:chapterOrder/subchapter/:subchapterOrder',
  't/book/chapter/:chapterOrder',
  'challenge',
  'resources/:resourceId',
  'resources/:resourceId/activities/:activityId',
  'resources/:resourceId/activities/:activityId/view',
];

export const isLegacyLessonPathname = (
  lessonPathname: string,
  pathname: string,
) =>
  LEGACY_LESSON_PATHS.some(legacyPath =>
    matchPath(`${lessonPathname}/${legacyPath}`, pathname),
  );
